import { TbCheck, TbLoader2, TbWifiOff } from "solid-icons/tb";
import { Match, Show, Switch } from "solid-js";
import { isServer } from "solid-js/web";
import { useI18n } from "~/i18n/context";
import { useWire } from "~/wire";

export const OfflineBanner = () => {
  const wire = useWire();
  const { t } = useI18n();

  const connectivityState = () => (isServer ? "online" : wire.connectivity.state());

  const shouldShow = () => {
    const state = connectivityState();
    return state === "offline" || state === "reconnecting" || state === "restored";
  };

  return (
    <Show when={!isServer && shouldShow()}>
      <div role="alert" aria-live="assertive" aria-atomic="true">
        <Switch>
          <Match when={connectivityState() === "offline"}>
            <div class="border-b border-amber-400 bg-amber-100 px-3 py-2 dark:border-amber-600 dark:bg-amber-900/80">
              <div class="flex items-center justify-center gap-2">
                <TbWifiOff class="size-4 shrink-0 text-amber-700 dark:text-amber-300" aria-hidden="true" />
                <span class="text-xs font-medium text-amber-800 dark:text-amber-200">
                  {t("connectivity_offline_title")}
                </span>
                <span class="hidden text-xs text-amber-700 sm:inline dark:text-amber-300">
                  {t("connectivity_offline_description")}
                </span>
              </div>
            </div>
          </Match>
          <Match when={connectivityState() === "reconnecting"}>
            <div class="border-b border-yellow-400 bg-yellow-100 px-3 py-2 dark:border-yellow-600 dark:bg-yellow-900/80">
              <div class="flex items-center justify-center gap-2">
                <TbLoader2
                  class="size-4 shrink-0 animate-spin text-yellow-700 dark:text-yellow-300"
                  aria-hidden="true"
                />
                <span class="text-xs font-medium text-yellow-800 dark:text-yellow-200">
                  {t("connectivity_reconnecting_title")}
                </span>
              </div>
            </div>
          </Match>
          <Match when={connectivityState() === "restored"}>
            <div class="border-b border-green-400 bg-green-100 px-3 py-2 dark:border-green-600 dark:bg-green-900/80">
              <div class="flex items-center justify-center gap-2">
                <TbCheck class="size-4 shrink-0 text-green-700 dark:text-green-300" aria-hidden="true" />
                <span class="text-xs font-medium text-green-800 dark:text-green-200">
                  {t("connectivity_restored_title")}
                </span>
              </div>
            </div>
          </Match>
        </Switch>
      </div>
    </Show>
  );
};
